import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, grey3, grey5 } from 'approot/shared/styles/colours.style';
import {
  spacing16,
  spacing24,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { PrimaryButton } from 'approot/shared/styles/buttons/primary-button.style';
import { A4 } from './activity-builder-a4.style';

export const PrintModalContainer = styled.div`
  display: flex;
`;

export const PrintModalOptions = styled.div`
  width: ${rem(252)};
  ${PrimaryButton} {
    width: 100%;
    margin-bottom: ${rem(spacing16)};
  }
`;

export const PrintModalPrintPreviewContainer = styled.div`
  flex-grow: 1;
  margin-right: ${rem(spacing40)};
`;

export const PrintModalPrintPreview = styled.div`
  position: relative;
  background-color: ${grey3};
  border-radius: ${rem(4)};
  border: 1px solid ${grey5};
  padding-top: 70.70347%;
  overflow: hidden;
  margin-bottom: ${rem(spacing24)};
`;

export const PrintModalPrintPreviewContents = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  background-color: ${grey1};
`;

export const PrintModalPrintPreviewA4 = styled.div`
  ${A4} {
    position: static;
  }
`;
